import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import useSWR from 'swr'
import {
    CustomerAPI,
    CustomerFetcher,
    SaveCustomerAPI,
} from '../../apis/CustomerAPI'
import AddressesComponent from '../../components/AddressesComponent'
import ErrorAlert from '../../components/Alerts/ErrorAlert'
import { Primary } from '../../components/Buttons/Primary'
import Loader from '../../components/Loader'
import MyAccountWrapper from '../../components/MyAccountWrapper'
import SuccessNotice from '../../components/Notices/SuccessNotice'
import { TextInput } from '../../helpers/checkout'
import { sleep } from '../../helpers/utils'

/**
 * Add try and catch to the fetchCustomer function
 */

/**
 * @TODO
 * Should/Can we make these pages static too ?
 * Need to handle Pagination on react level
 */

const fields = {
    billing: {
        first_name: {
            label: 'First Name',
            type: 'text',
        },
        last_name: {
            label: 'Last Name',
            type: 'text',
        },
        email: {
            label: 'Email',
            type: 'email',
        },
        phone: {
            label: 'Phone',
            type: 'phone',
        },
        address_1: {
            label: 'Street Address',
            type: 'text',
        },
        address_2: {
            label: 'Line 2 (Apt, suite, unit, etc.)',
            type: 'text',
        },
        city: {
            label: 'City',
            type: 'text',
        },
        state: {
            label: 'State',
            type: 'text',
        },
        postcode: {
            label: 'Postcode',
            type: 'text',
        },
    },
    shipping: {
        first_name: {
            label: 'First Name',
            type: 'text',
        },
        last_name: {
            label: 'Last Name',
            type: 'text',
        },
        address_1: {
            label: 'Street Address',
            type: 'text',
        },
        address_2: {
            label: 'Line 2 (Apt, suite, unit, etc.)',
            type: 'text',
        },
        city: {
            label: 'City',
            type: 'text',
        },
        state: {
            label: 'State',
            type: 'text',
        },
        postcode: {
            label: 'Postcode',
            type: 'text',
        },
    },
}
function Addressess() {
    const { data: customer, error: swrError } = useSWR(
        CustomerAPI.getCustomer,
        CustomerFetcher,
    )

    const { register, setValue, handleSubmit } = useForm()
    const [edit, setEdit] = useState(false)
    const [status, setStatus] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleHideNotice = () => {
        sleep(2000).then(() => {
            setStatus('')
        })
    }

    const handleForm = async (data) => {
        try {
            setLoading(true)
            await SaveCustomerAPI.save(data)
            setStatus('Addresses Saved!')
            setError('')
            handleHideNotice()
        } catch (e) {
            setError(e.response.data.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (customer) {
            setValue('billing', customer.billing)
            setValue('shipping', customer.shipping)
        }
    }, [edit, customer, setValue])

    return (
        <MyAccountWrapper
            title={'My Addressess'}
            error={error}
            description={' Here, you can manage your addresses.'}>
            {loading && <Loader text="Saving..." />}
            {!edit ? (
                swrError ? (
                    'Failed to Load'
                ) : customer ? (
                    <div className="bg-gray-50 p-6">
                        <AddressesComponent order={customer} />
                        <div className="pt-4">
                            <Primary onClick={() => setEdit(true)}>
                                Edit Addresses
                            </Primary>
                        </div>
                    </div>
                ) : (
                    'Loading...'
                )
            ) : (
                <form onSubmit={handleSubmit(handleForm)}>
                    <h2 className="text-xl border-b-2 my-5 py-2">Billing</h2>
                    <div className="md:grid md:grid-cols-2 space-y-5 md:space-y-5 gap-2">
                        {Object.keys(fields.billing).map((field) => (
                            <div className="my-2" key={field}>
                                <TextInput
                                    shouldValidate={true}
                                    isRequired={true}
                                    register={register}
                                    name={`billing.${field}`}
                                    label={fields.billing[field].label}
                                    type={fields.billing[field].type}
                                />
                            </div>
                        ))}
                    </div>
                    <h2 className="text-xl border-b-2 my-5 py-2">Shipping</h2>
                    <div className="md:grid md:grid-cols-2 space-y-5 md:space-y-5 gap-2">
                        {Object.keys(fields.shipping).map((field) => (
                            <div className="my-2" key={field}>
                                <TextInput
                                    shouldValidate={true}
                                    isRequired={true}
                                    register={register}
                                    name={`shipping.${field}`}
                                    label={fields.shipping[field].label}
                                    type={fields.shipping[field].type}
                                />
                            </div>
                        ))}
                    </div>
                    <div
                        className="
                                flex justify-between
                                md:block
                                space-x-2 mt-5">
                        <Primary type="submit">Save Addresses</Primary>
                        <button
                            className="text-sm text-gray-800"
                            onClick={() => setEdit(false)}>
                            Cancel
                        </button>
                    </div>
                </form>
            )}

            {error && <ErrorAlert error={error} />}
            {status && <SuccessNotice>{status}</SuccessNotice>}
        </MyAccountWrapper>
    )
}

export default Addressess
